<div class="panel-body " *ngIf="dispositionUndisciplined===undefined">
	<div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
			<div class="panel-title">
				Disposition Result 
			</div>
			<div class="panel-body ">
				No Disposition Result information available for this allegation.
			</div>
	</div>
</div>
<!-- <div class="panel-body " *ngIf="dispositionUndisciplined===undefined">
	No Disposition Result information available for this allegation.
</div> -->
<div class="panel-body " *ngIf="dispositionUndisciplined!==undefined">
    <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
      <div class="panel-title">
        Disposition Result
      </div>
     <div class="panel-body ">
        <div class="col-md-6 panel panel-default">
            <div class="panel panel-default " *ngIf="dispositionUndisciplined.getDispositionDate() !== ''">
            <div class="panel-title">
                Disposition Date
            </div>
            <div class="panel-body"></div>
               {{dispositionUndisciplined.getDispositionDate() | date:'MM/dd/yyyy'}}
            </div>
            <div class="panel panel-default " *ngIf="dispositionUndisciplined.getParents().length !==0">
            <div class="panel-title">
                Parent/Guardian/Custodian Assigned 
            </div>
            <div class="panel-body" *ngFor="let parent of dispositionUndisciplined.getParents(); let al = index">
                {{parent.getPartyName() + ' (' + parent.getRelationship() + ')'}}
            </div>

            </div>
        </div>
        <div class="col-sm-6 panel panel-default ">
          <div class="panel panel-default " *ngIf="dispositionUndisciplined.getDateOfFiling() !== ''">
          <div class="panel-title">
            Disposition EO Date
          </div>
          <div class="panel-body">
              {{dispositionUndisciplined.getDateOfFiling() | date:'MM/dd/yyyy'}}
          </div>
          </div>
        </div>
        </div>
        <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
						<div class="panel panel-default" *ngIf="dispositionUndisciplined.getOtherAllegations().length !=0">
								<div class="panel-title">
									Other Allegations Included On Order
								</div>
								<div class="panel-body" >
										<div class="row table-responsive">
												<table id="allegations-table" class="table table-condensed table-striped">
														<thead>
																<tr>
																		<th id="V122c">
																			<span class="field-code ">V122c json='allegations.pleadingType'</span>
																			Pleading Type <br> 
																			<span class="field-code ">V122c json='allegations.clockDate'</span>
																			And Clock Date
																		</th>
																		<th id="V121c">
																			<span class="field-code ">V121c json='allegations.allegation'</span>
																				Allegation <br>
																				<span class="field-code ">V121c json='allegations.offenseDate'</span>
																				Offense Date
																			</th>
																		 </tr>
														</thead>
														<tbody  *ngFor="let otherAllegation of dispositionUndisciplined.getOtherAllegations()let i = index;">                            
																 <tr >
																	<td id="{{'juvenile-caseDetails-dispositionUndisciplined-' + i + '-pleadingType'}}">
																		{{otherAllegation.getOtherPleadingTypeDesc()}} <br>
																		{{otherAllegation.getOtherPleadingDate() | date:'MM/dd/yyyy'}} {{otherAllegation.getOtherPleadingTime()}}</td>
																	<td id="{{'juvenile-caseDetails-dispositionUndisciplined-' + i + '-allegationDescription'}}">
																		{{otherAllegation.getOtherAllegationDescription()}} <br>        
																		{{otherAllegation.getOtherAllegationOffenseDate() | date:'MM/dd/yyyy'}}</td>
																</tr>    
															 </tbody>
												</table>
										</div>
								</div>
								</div>
          <div class="panel panel-default" *ngIf="dispositionUndisciplined.getFactsNotes()!==''">
            <div class="panel-title">
              Findings
            </div>
           <div class="panel-body">
							<B>After considering the evidence, the Court makes the following findings of fact:</B>
              <ul style="list-style-type:disc">
			  				<li>{{dispositionUndisciplined.getFactsNotes()}}</li>
              </ul>
           </div>
          </div>
        <div class="panel panel-default" *ngIf="dispositionUndisciplined.getProtectiveSupervisionInd()!=='NE'">
            <div class="panel-title">
             Protective Supervision
            </div>
            <div class="panel-body" >
              <ul style="list-style-type:disc">
                <div *ngIf="dispositionUndisciplined.getProtectiveSupervisionInd() === 'ON'">
                <li>Protective Supervision [G.S. 7B-2503(2)].</li>
                <ul style="list-style-type:disc">
									<span *ngIf="dispositionUndisciplined.getSupervisionPeriod()!==''">
									<li> Supervision period:{{dispositionUndisciplined.getSupervisionPeriod()}}</li></span>
				  <div *ngIf="dispositionUndisciplined.getGoodBehaviorInd() === 'ON'" >
                    <li>Remain on good behavior and not violate any laws.</li>
                  </div>
				  <div *ngIf="dispositionUndisciplined.getAttendSchoolInd() === 'ON'" >
                    <li>Attend school regularly.</li>
                  </div>
				  <div *ngIf="dispositionUndisciplined.getMaintainGradesInd() === 'ON'" >
                    <li>Maintain passing grades in at least {{dispositionUndisciplined.getNumberCourses()}} courses. </li>
                  </div>
				  <div *ngIf="dispositionUndisciplined.getNotAssociateInd() === 'ON'" >
										<li>Not associate with:</li>
										<span *ngIf="dispositionUndisciplined.getNotAssociateNotes()!==''">
										<ul style="list-style-type:disc">
										<li>{{dispositionUndisciplined.getNotAssociateNotes()}}</li>
										</ul></span>
          </div>
				  <div *ngIf="dispositionUndisciplined.getNotInPlacesInd() === 'ON'" >
										<li>Not be in the following places(s):</li>
										<span *ngIf="dispositionUndisciplined.getNotInPlacesNotes()!==''">
										<ul style="list-style-type:disc">
										<li>{{dispositionUndisciplined.getNotInPlacesNotes()}}</li>
										</ul></span>
          </div>
				  <div *ngIf="dispositionUndisciplined.getAbideCurfewInd() === 'ON'" >
										<li>Abide by the following curfew:</li>
										<span *ngIf="dispositionUndisciplined.getAbideCurfewNotes()!==''">
										<ul style="list-style-type:disc">
										<li>{{dispositionUndisciplined.getAbideCurfewNotes()}}</li>
										</ul></span>
          </div>
				  <div *ngIf="dispositionUndisciplined.getReportToCounselorInd() === 'ON'" >
                    <li>Report to a court counselor as often as required by the court counselor.</li>
                  </div>
				  <div *ngIf="dispositionUndisciplined.getEmployedRegularlyInd() === 'ON'" >
                    <li>Be employed regularly if not attending school</li>
                  </div>
				  <div *ngIf="dispositionUndisciplined.getOtherInd() === 'ON'" >
										<li>Other:</li>
										<span *ngIf="dispositionUndisciplined.getOtherNotes()!==''">
										<ul style="list-style-type:disc">
										<li>{{dispositionUndisciplined.getOtherNotes()}}</li>
										</ul></span>
          </div>
                </ul>
                </div>
              </ul>
            </div>
        </div>
        <div class="panel panel-default" *ngIf="dispositionUndisciplined.isOrderDetailsPresent() !== 'NE'">
            <div class="panel-title">
              Order
            </div>
            <div class="panel-body">
              <B>It is therefore ORDERED that:</B>
              <ul style="list-style-type:disc">
			  <div *ngIf="dispositionUndisciplined.getContinuanceInd() === 'ON'" >
                <li>Continuance for family to implement approved plan [G.S. 7B-2501(d)];</li>
				<ul style="list-style-type:disc">
				<span *ngIf="dispositionUndisciplined.getContinuancePeriod()!==''">
					<li>Continue for: {{dispositionUndisciplined.getContinuancePeriod()}}</li></span>
				<span *ngIf="dispositionUndisciplined.getContinuancePlan()!==''">
				<li>Continuance Plan:</li>
				<ul style="list-style-type:disc">
					<li>{{dispositionUndisciplined.getContinuancePlan()}}</li>
				</ul></span>
				</ul>
              </div>
			  <div *ngIf="dispositionUndisciplined.getExpertExamInd() === 'ON'" >
				<li>Examination by expert [G.S. 7B-2502(a)]:</li>
				<ul style="list-style-type:disc">
					<span *ngIf="dispositionUndisciplined.getExpertName()!==''">
					<li>Expert name or type: {{dispositionUndisciplined.getExpertName()}}</li></span>
					<span *ngIf="dispositionUndisciplined.getExpertHearingDate()!==''">
					<li>Expert Hearing Date: {{dispositionUndisciplined.getExpertHearingDate()}}</li></span>
				</ul>
			  </div>
			  <div *ngIf="dispositionUndisciplined.getInterdisciplineEvalInd() === 'ON'" >
				<li>Interdisciplinary evaluation[G.S. 7B-2502(a)].</li>
			  </div>
			  <div *ngIf="dispositionUndisciplined.getInHomeSupervisionInd() === 'ON'" >
				<li>In-Home Supervision With Conditions [G.S. 7B-2503(1)a].</li>
				<ul style="list-style-type:disc">
					<span *ngIf="dispositionUndisciplined.getSupervisedBy()!==''">
					<li>Supervised by: {{dispositionUndisciplined.getSupervisedBy()}}</li></span>
					<span *ngIf="dispositionUndisciplined.getSupervisionConditions()!==''">
					<li>Conditions of supervision:</li>
					<ul style="list-style-type:disc">
						<li>{{dispositionUndisciplined.getSupervisionConditions()}}</li>
					</ul></span>
				</ul>
			  </div>
			  <div *ngIf="dispositionUndisciplined.getChangeOfCustodyInd() === 'ON'" >
				<li>Change of Custody [G.S. 7B-2503(1)b].</li>
				<ul style="list-style-type:disc">
					<div *ngIf="dispositionUndisciplined.getMotherCustodyInd() === 'ON'" >
						<li>The juvenile's mother: {{dispositionUndisciplined.getMothersName()}}</li>
					</div>
					<div *ngIf="dispositionUndisciplined.getFatherCustodyInd() === 'ON'" >
						<li>The juvenile's father: {{dispositionUndisciplined.getFathersName()}}</li>
					</div>
					<div *ngIf="dispositionUndisciplined.getOtherCustodyInd() === 'ON'" >
						<li>Other: {{dispositionUndisciplined.getOtherName()}}</li>
					</div>
					<div *ngIf="dispositionUndisciplined.getCountyCustodyInd() === 'ON'" >
						<li>The {{dispositionUndisciplined.getCountyName()}} County Department of Social Services.</li>
					</div>
				</ul>
			  </div>
			  <div *ngIf="dispositionUndisciplined.getExcuseFromSchoolInd() === 'ON'" >
				<li>Excuse from school attendance [G.S. 7B-2503(3)].</li>
				<ul style="list-style-type:disc">
					<span *ngIf="dispositionUndisciplined.getPlanNotes()!==''">
					<li>Comply to the following plan:</li>
					<ul style="list-style-type:disc">
						<li>{{dispositionUndisciplined.getPlanNotes()}}</li>
					</ul></span>
				</ul>
			  </div>
			  <div *ngIf="dispositionUndisciplined.getParentRequirementsInd() === 'ON'" >
				<li>Requirements for parent, guardian, custodian [G.S. 7B-2700 through 2794].</li>
				<ul style="list-style-type:disc">
					<li>The juvenile's</li>
					<ul style="list-style-type:disc">
						<div *ngIf="dispositionUndisciplined.getMotherComplyInd() === 'ON'" >
							<li>mother</li>
						</div>
						<div *ngIf="dispositionUndisciplined.getFatherComplyInd() === 'ON'" >
							<li>father</li>
						</div>
						<div *ngIf="dispositionUndisciplined.getGuardianComplyInd() === 'ON'" >
							<li>guardian</li>
						</div>
						<div *ngIf="dispositionUndisciplined.getCustodianComplyInd() === 'ON'" >
							<li>custodian</li>
						</div>
						<ul style="list-style-type:disc">
							<li>comply with the "Supplemental Order to Parent, Guardian, Or Custodian of Undisciplined or Delinquent Juvenile"</li>
						</ul>
					</ul>
				</ul>
			  </div>
			  <div *ngIf="dispositionUndisciplined.getOtherOrderInd() === 'ON'" >
				<li>Other:</li>
				<span *ngIf="dispositionUndisciplined.getOtherOrderNotes()!==''">
				<ul style="list-style-type:disc">
					<li>{{dispositionUndisciplined.getOtherOrderNotes()}}</li>
				</ul></span>
			  </div>
			  </ul>
            </div>    
        </div>
    </div>
   </div>
 </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/disposition-undisciplined/disposition-undisciplined.component.html